import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import { Zap } from 'lucide-react'

const Header: React.FC = () => {
  const { t, i18n } = useTranslation()

  // Get home link based on current language
  const getHomeLink = () => {
    return i18n.language === 'zh' ? '/zh/' : '/'
  }

  return (
    <motion.header 
      className="apple-glass sticky top-0 z-50"
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, ease: [0.25, 0.1, 0.25, 1] }}
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-start h-16">
          {/* Logo */}
          <Link to={getHomeLink()}>
            <motion.div 
              className="flex items-center space-x-3"
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              <div className="flex items-center justify-center w-10 h-10 bg-apple-blue rounded-apple">
                <Zap className="w-5 h-5 text-white" />
              </div>
              <div>
                <span className="text-lg font-semibold text-apple-gray-900 tracking-tight">
                  {t('title')}
                </span>
                <p className="text-xs text-apple-gray-500 hidden sm:block">
                  {t('subtitle')}
                </p>
              </div>
            </motion.div>
          </Link>
        </div>
      </div>
    </motion.header>
  )
}

export default Header
